<ion-label *ngIf="title" class="select-title">{{ title }}</ion-label>
<ng-content select="upp-select-item"></ng-content>
<ng-content select="upp-select-list"></ng-content>